/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Low_EnergyInputs */

const cs_form_low_energy = /** @type {(inputs: Form_Low_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nízkoenergetická nemovitost`)
};

const en_form_low_energy = /** @type {(inputs: Form_Low_EnergyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low-energy property`)
};

/**
* | output |
* | --- |
* | "Low-energy property" |
*
* @param {Form_Low_EnergyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_low_energy = /** @type {((inputs?: Form_Low_EnergyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Low_EnergyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_low_energy(inputs)
	return cs_form_low_energy(inputs)
});